/**
 * Device Icon Component - Renders device type icon
 * 
 * AI Agent Note: This component handles rendering both image icons and emoji fallbacks.
 * Images are used for all device types except 'other' which uses emoji.
 */

import React from 'react';
import { DeviceType } from '../types';
import { DEVICE_TYPE_ICONS } from '../config/constants';

interface DeviceIconProps {
  type: DeviceType;
  className?: string;
  size?: number;
}

const DeviceIcon: React.FC<DeviceIconProps> = ({ type, className = '', size = 28 }) => {
  const icon = DEVICE_TYPE_ICONS[type];
  
  // Check if icon is an image path or emoji
  const isImage = icon.startsWith('/');
  
  if (isImage) {
    return (
      <img 
        src={icon} 
        alt={type}
        className={className}
        style={{ 
          width: `${size}px`, 
          height: `${size}px`,
          objectFit: 'contain'
        }}
      />
    );
  }
  
  // Fallback to emoji for 'other' type
  return (
    <span 
      className={className}
      style={{ fontSize: `${size}px`, lineHeight: 1 }}
    >
      {icon}
    </span>
  );
};

export default DeviceIcon;
